import { GetTagsDocument, GetTagsQuery, GetTagsQueryVariables } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Tag = GetTagsQuery['ats']['tags'][number]

export const useTags = (variables?: GetTagsQueryVariables) => {
  const { data, loading } = useQuery(GetTagsDocument, {
    variables,
  })

  return {
    loading,
    tags: data ? orderBy(data.ats.tags, [(tag) => tag.name.toLowerCase()]) : [],
  }
}
